/*eslint-disable */
// Incrementar VERSION a cada atualização de conteúdo necessária.
const VERSION = "v1";
const CACHE_NAME = `cache-${VERSION}`;
const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export function register(config) {
  if ("serviceWorker" in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener("load", () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          console.log(
            "Esta aplicação web está sendo servida cache-first por um service worker. Para aprender mais, visite https://bit.ly/CRA-PWA"
          );
        });
      } else {
        registerValidSW(swUrl, config);
      }
    });
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.update();
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              console.log(
                "Novo conteúdo está disponível e será usado quando todas as guias deste site forem fechadas. Veja https://bit.ly/CRA-PWA."
              );
              window.location.reload();
              // Execute o callback de atualização
              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              console.log(
                "Conteúdo está armazenado em cache para uso offline."
              );

              // Execute o callback de sucesso
              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };

      registration.addEventListener("install", (event) => {
        // Força o Service Worker a se tornar ativo imediatamente após a instalação
        event.waitUntil(registration.skipWaiting());
      });

      registration.addEventListener("activate", (event) => {
        // Assume o controle imediato das páginas abertas
        event.waitUntil(registration.clients.claim());
      });

      // Forçar a atualização do Service Worker se uma nova versão estiver disponível
      registration.addEventListener("updatefound", () => {
        const newWorker = registration.installing;
        newWorker.addEventListener("statechange", (event) => {
          if (event.target.state === "installed") {
            if (navigator.serviceWorker.controller) {
              // Notificar usuário sobre a atualização ou recarregar a página
              console.log("Uma nova versão do Service Worker foi instalada.");
              // Por exemplo, você pode exibir um prompt para o usuário recarregar a página
            }
          }
        });
      });

    })
    .catch((error) => {
      console.error("Erro durante o registro do service worker:", error);
    });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { "Service-Worker": "script" },
  })
    .then((response) => {
      const contentType = response.headers.get("content-type");
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf("javascript") === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            registration.waiting.postMessage({ type: "SKIP_WAITING" });
            //window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log(
        "Nenhuma conexão de internet encontrada. Aplicativo está rodando em modo offline."
      );
    });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
}
